
import { useEffect } from 'react'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import ResetPassword from '../../Users/Dialogs/ResetPassword.jsx'
import Login from '../../Users/Pages/Login.jsx'


const FrontPage = () => {
  const { setLoginDialog } = useGlobalContext()

  useEffect(() => {
    setLoginDialog(true)
  }, [])

  return (
    <>
      <Login />
      <ResetPassword />
    </>
  )
}

export default FrontPage
